import React from "react";
import "./login.scss";
import { Redirect } from "react-router-dom";
import axios from "axios";
const lockIcon = (
  <img alt="" className="icon" src={require("./img/locked-icon.png")} />
);

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      error: ""
    };

    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = event => {
    event.preventDefault();

    if (!this.state.username) {
      return this.setState({ error: "Se requiere usuario" });
    }

    if (!this.state.password) {
      return this.setState({ error: "Se requiere contraseña" });
    }

    return this.setState({ error: "" });
  };

  handleUserChange = event => {
    this.setState({
      username: event.target.value
    });
  };

  handlePasswordChange = event => {
    this.setState({
      password: event.target.value
    });
  };

  renderRedirect = () => {
    if (this.state.authenticated) {
      return <Redirect to="/bienvenido" />;
    }
  };
  login = () => {
    const userData = {
      username: this.state.username,
      password: this.state.password
    }

    let apiUrl = (window.location.hostname === "localhost") ? "71.6.202.19" : window.location.hostname
    let protocol = (window.location.hostname === "localhost") ? "http://" : window.location.protocol+"//"
    let port = (window.location.hostname === "localhost") ? ":8081" : window.location.port
    
    axios.post(`${ protocol }${ apiUrl }:${ port }/api/authenticate`, userData).then(resp => {
      if( resp.data.token !== undefined ) {
        localStorage.setItem('urlQlik', resp.data.token)
      }

      this.setState({
        authenticated: true
      })
    }).catch(error => {
      console.log(error);
      console.log(error.response);

      alert(error.response.data.error)
    });
  };

  render() {
    if (window.innerWidth <= 768) {
      // ! si es Mobile
      return (
        <div id="login">
          <div className="bg-fondo-mobile min-vh-100 w-100"></div>
            <div className="p-fixed t-0 l-0 w-100  d-flex justify-content-around align-items-center flex-column">
              <div className=" w-100 d-flex justify-content-center min-vh-100">
                <div className="text-center w-100">
                  <div id="login-card" className="text-center p-0 h-100 d-flex flex-column justify-content-between pt-0">
                    <div className="header"></div>
                    <div className="text-white d-flex flex-column align-items-start pb-2 px-4 border-l ml-4">
                      <h3>Bienvenido al</h3>
                      <h3><strong className="text-shadow">Portal Inteligente</strong></h3>
                    </div>
                    {this.LoginFormMobile()}
                  </div>
                </div>
              </div>
            </div>
          </div>
      );
    } else {
      // ! si es desktop
      return (
        <div id="login">
          <div className="bg-fondo min-vh-100 w-75"></div>
          <div className="p-fixed t-0 l-0 w-100 min-vh-100 d-flex justify-content-between align-items-center">
            <div className="text-white min-vh-100 px-5 mt-4 d-flex justify-content-start">
              <div className="w-100">
                <h2 className="fs-5 mt-5 pt-2">Bienvenido</h2>
                <hr className="separador w-100 mt-3"></hr>
              </div>
              <div className="fs-5 mt-auto mb-auto w-100 lm-240">
                <h1>Portal</h1>
                <h1><strong>Inteligente</strong></h1>
              </div>
            </div>
            <div className="px-5 w-50 d-flex justify-content-end mt-5">
              <div className="card text-center login-card h-100 w-75 p-3 mr-5 rounded-0">
                <div id="login-card" className="card-body text-center p-0">
                  <img className="logo-blue" alt="Presto" src={require("./img/logo-presto.png")}></img>
                  <div className="p-3">
                    <hr className="separador mt-2 mb-4"></hr>
                    {this.LoginForm()}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  // ! desktop
  LoginForm = () => {
    return (
      <form onSubmit={this.handleSubmit} className="">
        <div className="form-group flex-column d-flex justify-content-center text-left">
          <label className="text-white">Usuario:</label>
          <input type="text" id="username" className="form-control my-3" value={this.state.username} onChange={this.handleUserChange}></input>
          <label className="text-white mt-3">Contraseña:</label>
          <input type="password" id="password" className="form-control my-3" value={this.state.password} onChange={this.handlePasswordChange}></input>
        </div>

        <div>{this.renderRedirect()}</div>
        <button onClick={this.login} type="submit" id="login-btn" className="text-white login-btn btn px-5 py-1">
          ENTRAR
        </button>
      </form>
    );
  };
  // ! mobile
  LoginFormMobile = () => {
    return (
      <form onSubmit={this.handleSubmit} className="px-5 mb-5">
        <div className="pb-4">
          <img className="logo-white" alt="Presto" src={require("./img/logo-presto.png")}></img>
        </div>
        <div className="form-group flex-column d-flex justify-content-center align-items-center">
          <input type="text" id="username" placeholder="Usuario" className="form-control user-icon mb-3 py-2 px-4 shadow outline-0" value={this.state.username} onChange={this.handleUserChange}></input>
          <input type="password" id="password" placeholder="Contraseña" className="form-control password-icon my-3 py-2 px-4 shadow outline-0" value={this.state.password} onChange={this.handlePasswordChange}></input>
        </div>
        <div>{this.renderRedirect()}</div>
        <button onClick={this.login} type="submit" id="login-btn-mobile" className="text-white login-btn btn px-5 py-2 mb-5 mt-0">
          Entrar
        </button>
      </form>
    );
  };
}

export default Login;
